import { createTimeshareIntroductionInfoQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useTimeshareIntroductionInfoQuery = createTimeshareIntroductionInfoQuery(HTTP_CONFIG.API.Optimizely.url)
